import * as types from './mutation-types'

export default {
  [types.SET_JOURNEYS] (state, payload) {
    state.journeys = payload.data
    state.pagination = { total: payload.total, current_page: payload.current_page }
  },
  [types.SET_JOURNEY] (state, payload) {
    state.journey = payload
    if (payload && payload.nodes) {
      // Sanitizar config: PHP retorna [] quando vazio, JS precisa de {}
      state.nodes = payload.nodes.map(n => ({
        ...n,
        config: n.config && !Array.isArray(n.config) ? n.config : {}
      }))
    }
  },
  /**
   * Aplica o retorno de um save.
   *
   * `reconcile` = houve edição local depois que o request partiu. Nesse caso a
   * resposta do servidor está desatualizada e NÃO pode substituir os nós — só
   * adotamos os ids recém-criados. Sem isso, tudo que o usuário mexeu durante o
   * request em voo era apagado e o campo aparecia em branco ao reabrir o nó.
   */
  [types.APPLY_SAVE_RESULT] (state, { journey, sentKeys, reconcile }) {
    const savedNodes = (journey && journey.nodes) || []

    // chave local (temp_x) -> id real, casando pela posição enviada no payload
    const byPosition = {}
    savedNodes.forEach(n => { byPosition[n.position] = n })

    const remap = {}
    ;(sentKeys || []).forEach((key, index) => {
      const saved = byPosition[index]
      if (saved && typeof key === 'string' && key.startsWith('temp_')) {
        remap[key] = saved.id
      }
    })

    if (reconcile || !(journey && journey.nodes)) {
      state.nodes = state.nodes.map(n => {
        const key = n.id || n._tempId
        const next = { ...n }
        if (remap[key] !== undefined) {
          next.id = remap[key]
          delete next._tempId
        }
        // ramos apontam para o pai pela chave local — precisa acompanhar o id novo
        if (n.parent_node_id && remap[n.parent_node_id] !== undefined) {
          next.parent_node_id = remap[n.parent_node_id]
        }
        return next
      })
    } else {
      state.nodes = savedNodes.map(n => ({
        ...n,
        config: n.config && !Array.isArray(n.config) ? n.config : {}
      }))
    }

    // `journey.nodes` precisa acompanhar `state.nodes`: o ChangeStatus recommita
    // a journey inteira via SET_JOURNEY, que repovoa os nós a partir daí — com a
    // cópia do servidor guardada aqui, a reconciliação seria desfeita depois.
    state.journey = { ...journey, nodes: state.nodes }

    // sem isto o nó recém-criado perdia a seleção (selectedNodeId continuava
    // sendo o _tempId) e o painel de edição fechava sozinho no meio da configuração
    if (remap[state.selectedNodeId] !== undefined) {
      state.selectedNodeId = remap[state.selectedNodeId]
    }
  },
  [types.SET_NODES] (state, payload) {
    state.nodes = payload
    state.revision++
  },
  [types.ADD_NODE] (state, payload) {
    state.nodes.push(payload)
    state.dirty = true
    state.revision++
  },
  [types.UPDATE_NODE] (state, payload) {
    const payloadId = payload.id || payload._tempId
    const index = state.nodes.findIndex(n => (n.id || n._tempId) === payloadId)
    if (index !== -1) {
      state.nodes.splice(index, 1, payload)
    }
    state.dirty = true
    state.revision++
  },
  [types.REMOVE_NODE] (state, nodeId) {
    const idsToRemove = new Set([nodeId])
    let changed = true
    while (changed) {
      changed = false
      state.nodes.forEach(n => {
        const nId = n.id || n._tempId
        if (!idsToRemove.has(nId) && n.parent_node_id && idsToRemove.has(n.parent_node_id)) {
          idsToRemove.add(nId)
          changed = true
        }
      })
    }
    state.nodes = state.nodes.filter(n => !idsToRemove.has(n.id || n._tempId))
    if (idsToRemove.has(state.selectedNodeId)) {
      state.selectedNodeId = null
    }
    state.dirty = true
    state.revision++
  },
  [types.SET_SELECTED_NODE] (state, nodeId) {
    state.selectedNodeId = nodeId
  },
  [types.SET_DIRTY] (state, payload) {
    state.dirty = payload
  },
  [types.SET_LOADING] (state, payload) {
    state.loading = payload
  },
  [types.SET_SAVING] (state, payload) {
    state.saving = payload
  },
  [types.SET_REFERENCE_DATA] (state, payload) {
    if (payload.emailTemplates !== undefined) state.emailTemplates = payload.emailTemplates
    if (payload.waTemplates !== undefined) state.waTemplates = payload.waTemplates
    if (payload.statuses !== undefined) state.statuses = payload.statuses
    if (payload.groups !== undefined) state.groups = payload.groups
    if (payload.tags !== undefined) state.tags = payload.tags
    if (payload.forms !== undefined) state.forms = payload.forms
    if (payload.journeysList !== undefined) state.journeysList = payload.journeysList
    if (payload.fieldTypes !== undefined) state.fieldTypes = payload.fieldTypes
    if (payload.refStatuses !== undefined) state.refStatuses = payload.refStatuses
    if (payload.formConditionFields !== undefined) state.formConditionFields = payload.formConditionFields
    if (payload.followUpRules !== undefined) state.followUpRules = payload.followUpRules
  },
  [types.SET_ANALYTICS] (state, payload) {
    state.analytics = { ...state.analytics, ...payload }
  }
}
